import { InduccionEstado } from "../common/enumModel";
import { IFilterInduccionModel } from "../interfaces/induccion/IFilterInduccionModel";

export class FilterInduccionModel implements IFilterInduccionModel {        
    idInducciones: number[];
    idEstado: InduccionEstado;
    estados: number[];
    codigoSolicitud: string;
    nombreContratista: string;
    nombreEmpleado: string;
    nroDocumento: string;
    fechaInicioAprobacion?: Date;
    fechaFinAprobacion?: Date;
    fechaInicioInduccion?: Date;
    fechaFinInduccion?: Date;
    page: number;
    pageSize: number;
    sedes: number[];
    solicitante: string;
    idCompania: number;

    constructor(){
        this.idInducciones = new Array<number>();
        this.idEstado = InduccionEstado.EMPTY;
        this.estados = [];
        this.codigoSolicitud = '';
        this.nombreContratista= '';
        this.nombreEmpleado= '';
        this.nroDocumento = '';
        // this.fechaInicioAprobacion = new Date();
        // this.fechaFinAprobacion = this.addDays(new Date(), 7);
        // this.fechaInicioInduccion = new Date();
        // this.fechaFinInduccion = this.addDays(new Date(), 7);
        this.page = 1;
        this.pageSize = 30;
        this.sedes = [];
        this.solicitante = '';
        this.idCompania = 0;
    }
}